import * as React from "react";
import Button from "@mui/material/Button";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import TableCell from "@mui/material/TableCell";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ButtonGroup from "@mui/material/ButtonGroup";
import DeleteIcon from "@mui/icons-material/Delete";

import { columns, emptyWarehouse } from "./common";

export default function WarehouseEditableTableRow({ row, actions }) {
	const [name, setName] = React.useState(row.name);
	const [city, setCity] = React.useState(row.city);
	const [alias1C, setAlias1C] = React.useState(row.alias1C);

	const handleSaveRowClick = () => {
		actions.saveRow({
			id: row.id,
			name,
			city,
			alias1C,
		});
	};

	const handleCancelEditRowClick = () => {
		actions.cancelEdit(row.id);
	};

	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};

	const textInput = ({ value, setValue, disabled = false }) => (
		<TextField
			inputRef={(input) => input}
			sx={{
				width: "25ch",
				"& .Mui-focused": {
					width: "22ch",
				},
				"& .MuiInputBase-input": {
					width: "100%",
					height: 0,
				},
			}}
			variant="outlined"
			onChange={(event) => setValue(event.target.value)}
			value={value}
			disabled={disabled}
			inputProps={{ "aria-label": "value" }}
		/>
	);
	return (
		<>
			<TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
				{columns.map((column) => (
					<TableCell key={column.id} align={column.align}>
						{column.id === "buttons" && (
							<div>
								<div style={{ display: "flex", gap: 15 }}>
									<ButtonGroup
										variant="outlined"
										aria-label="outlined button group"
									>
										<Button
											onClick={() => handleSaveRowClick()}
											disabled={!name || !city || !alias1C}
										>
											<SaveIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleDeleteRowClick()}
											disabled={row.id === emptyWarehouse.id}
										>
											<DeleteIcon />
										</Button>
										<Button
											color="error"
											onClick={() => handleCancelEditRowClick()}
										>
											<CloseIcon />
										</Button>
									</ButtonGroup>
								</div>
							</div>
						)}
						{column.id === "name" &&
							textInput({ value: name, setValue: setName })}
						{column.id === "city" &&
							textInput({ value: city, setValue: setCity })}
						{column.id === "alias1C" &&
							textInput({ value: alias1C, setValue: setAlias1C })}
					</TableCell>
				))}
			</TableRow>
		</>
	);
}
